import { useState, useEffect } from 'react';

const Hero = () => {
  const [displayedText, setDisplayedText] = useState('');
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const fullText = "Hello, I'm Ayomidotun";

  useEffect(() => {
    let index = 0;
    const typingInterval = setInterval(() => {
      if (index < fullText.length) {
        setDisplayedText(fullText.slice(0, index + 1));
        index++;
      } else {
        setIsTypingComplete(true);
        clearInterval(typingInterval);
      }
    }, 150); 

    return () => clearInterval(typingInterval);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-[100svh] sm:min-h-screen flex items-center justify-center pt-24 pb-8 sm:py-16 sm:pt-40 px-4 bg-white dark:bg-black relative overflow-hidden transition-colors duration-300">
      <div className="text-center max-w-4xl mx-auto py-8 sm:py-[30px] relative z-10">
        {/* Main Heading with Typing Animation */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold leading-tight text-black dark:text-white mb-4 sm:mb-6 tracking-tight transition-colors duration-300">
          {displayedText}
          <span className={`inline-block w-1 bg-black dark:bg-white ml-1 ${isTypingComplete ? 'animate-blink' : 'animate-pulse'}`} style={{ height: '1em' }}></span>
        </h1>
        
        {/* Subtitle */}
        <p 
          className="text-lg sm:text-2xl md:text-3xl text-gray-600 dark:text-gray-300 mb-8 sm:mb-12 font-normal leading-snug hero-animate-fade-up transition-colors duration-300"
          style={{ animationDelay: '2000ms' }}
        >
          Frontend Engineer & UI/UX Designer
        </p>
        
        {/* Description */}
        <p 
          className="text-base sm:text-lg text-gray-500 dark:text-gray-400 mb-8 sm:mb-12 max-w-2xl mx-auto leading-relaxed hero-animate-fade-up px-2 sm:px-0 transition-colors duration-300"
          style={{ animationDelay: '2200ms' }}
        >
          I craft clean, modern web experiences with thoughtful design and efficient code. 
          Passionate about creating digital solutions that make a difference.
        </p>
        
        {/* CTA Buttons */}
        <div 
          className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-10 sm:mb-16 hero-animate-fade-up px-4 sm:px-0"
          style={{ animationDelay: '2400ms' }}
        >
          <button 
            onClick={() => scrollToSection('projects')}
            className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-black dark:bg-white text-white dark:text-black text-sm sm:text-base font-medium cursor-pointer transition-all duration-300 hover:bg-gray-800 dark:hover:bg-gray-200 hover:-translate-y-0.5"
          >
            View My Work
          </button>
        </div>

        {/* Scroll indicator */}
        <div 
          className="flex flex-col items-center text-gray-400 dark:text-gray-500 hero-animate-fade-in transition-colors duration-300"
          style={{ animationDelay: '2600ms' }}
        >
          <span className="text-xs sm:text-sm mb-2 text-gray-400 dark:text-gray-500 transition-colors duration-300">
            Scroll to explore
          </span>
          <div className="w-px h-6 sm:h-8 bg-gradient-to-b from-gray-400 dark:from-gray-500 to-transparent animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;